interface ICliniciansCheckboxControl_OptimizedV2Props {
    checkedClinicians?: boolean;
    checkedDeactivatedClinicians?: boolean;

    onCheckClinicians?: () => void;
    onCheckDeactivatedClinicians?: () => void;
}

class CliniciansCheckboxControl_OptimizedV2 extends React.Component<ICliniciansCheckboxControl_OptimizedV2Props, never> {
    public render(): JSX.Element {
        return (
            <div style={{ display: "inline-flex", marginRight: "50px" }}>
                <label htmlFor="clinicians_id" className="uppercase" style={{ width: "100px" }} title={cacheStore.GetString("CliniciansLabel").toUpperCase()}>
                    <input
                        type="checkbox"
                        id="clinicians_id"
                        onChange={() => this.props.onCheckClinicians()}
                        checked={this.props.checkedClinicians}
                    />
                    {` ${cacheStore.GetString("CliniciansLabel")}`}
                </label>

                <label htmlFor="DeactivatedClinicians_id" className="uppercase" style={{ width: "150px" }}>
                    <input
                        type="checkbox"
                        id="DeactivatedClinicians_id"
                        onChange={() => this.props.onCheckDeactivatedClinicians()}
                        checked={this.props.checkedDeactivatedClinicians}
                        style={{ marginLeft: "10px" }}
                    />
                    {` ${cacheStore.GetString("DeactivatedMLabel")}`}
                </label>
            </div>
        );
    }
}

export { CliniciansCheckboxControl_OptimizedV2 };
